import { useReducer } from "react";

function sectionReducer(state, section) {
  if (state !== section) {
    return section;
  } else {
    return null;
  }
}

export function useSectionToggle(initialSection = null) {
  return useReducer(sectionReducer, initialSection);
}
